
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rate-estimate",
      function () {
        return require("private-next-pages/rate-estimate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rate-estimate"])
      });
    }
  